// AUTO-GENERATED GraphQL Builder for PaymentSplitLine
import * as Builders from '../';
export class PaymentSplitLineBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  vendorId(){ return this.add('vendorId'); }
  vendorName(){ return this.add('vendorName'); }
  share(){ return this.add('share'); }
  feePct(){ return this.add('feePct'); }
  amount(){ return this.add('amount'); }
  transferRef(){ return this.add('transferRef'); }
  note(){ return this.add('note'); }
}
